import React from 'react';

interface CompactRatingDisplayProps {
  rating: number;
  sigma: number;
  isUncertain?: boolean;
  className?: string;
}

const CompactRatingDisplay: React.FC<CompactRatingDisplayProps> = ({
  rating,
  sigma,
  isUncertain = false,
  className = ''
}) => {
  const wrapperClasses = isUncertain
    ? 'inline-flex items-center border border-edge-input rounded-full px-2 py-0.5 bg-surface-subtle'
    : 'inline-flex items-center border border-primary-200 rounded-full px-2 py-0.5 bg-primary-50';

  const ratingClasses = isUncertain ? 'text-muted' : 'text-heading';
  const sigmaClasses = isUncertain ? 'text-disabled' : 'text-body';

  return (
    <span className={`${wrapperClasses} ${className}`}>
      <span className={`font-mono font-bold ${ratingClasses}`}>{rating.toFixed(2)}</span>
      <span className={`ml-1 font-mono ${sigmaClasses}`}>
        (±{sigma.toFixed(2)})
      </span>
    </span>
  );
};

export default CompactRatingDisplay;
